import { Box } from "@mui/system";
import React, { useEffect } from "react";
import ConfirmationCard from "../../components/verification/confirmationCard";
import DivisionCmp from "../../components/cards/DivisionCmp";
import FacitlityActivationCmp from "../../components/verification/facilityActivationCmp";
import { HandleNext } from "../../models/sharedFunctions";
import { useMutation, useQueryClient } from "react-query";
import { getCustomerRegistrationInfo } from "../../services/loan.service";
import {
  ExistingLoanRequest,
  GetCustomerRegistrationInfoRequest,
  GetCustomerRegistrationInfoResponse,
  LoanTemplateInfo,
} from "../../models/loan.model";
import {
  CUSTOMER_INFO,
  EXISTING_LOANREQUEST,
  HAS_REGISTER_REQUEST,
  IS_CANCELABLE,
  IS_EDITABLE,
  LOAN_TEMPLATE_INFOS,
  NATIONAL_CODE,
  REFERENCE_KEY
} from "../../config/cacheKey";

export default function Confirmation({ handleNext }: HandleNext) {
  const queryClient = useQueryClient();
  const valuesNationalCode = new GetCustomerRegistrationInfoRequest();
  valuesNationalCode.nationalCode = queryClient.getQueryData<string>(
    NATIONAL_CODE
  );

  const CustomerRegistrationInfo = useMutation(getCustomerRegistrationInfo, {
    onSuccess: (data: GetCustomerRegistrationInfoResponse) => {
      queryClient.setQueryData(HAS_REGISTER_REQUEST, data.hasRegisterRequest);
      queryClient.setQueryData(IS_EDITABLE, data.isEditable);
      queryClient.setQueryData(IS_CANCELABLE, data.isCancelable);
      queryClient.setQueryData(CUSTOMER_INFO, data.customerInfo);
      queryClient.setQueryData(LOAN_TEMPLATE_INFOS, data.loanTemplateInfos);
      queryClient.setQueryData(EXISTING_LOANREQUEST, data.existingLoanRequest);
      queryClient.setQueryData(REFERENCE_KEY, data.existingLoanRequest.referenceKey);
    },
  });


  useEffect(() => {
    CustomerRegistrationInfo.mutateAsync(valuesNationalCode);
  }, []);

  const existingLoanRequest = queryClient.getQueryData<ExistingLoanRequest>(
    EXISTING_LOANREQUEST
  );
  const loanInfo = queryClient.getQueryData<LoanTemplateInfo[]>(
    LOAN_TEMPLATE_INFOS
  );
  const listloan = loanInfo
    ?.filter((item: any) => item.id == existingLoanRequest?.loanTemplateId)
    .map((item: any, index: number, array: any) => {
      return {
        title: item.title,
        cardImage: item.cardImage,
        id: item.id,
        maxAmount: item.maxAmount,
        profitPercentage: item.profitPercentage,
        expirationDate_Persian: item.expirationDate_Persian,
        financialSupplierName: item.financialSupplierName,
        financialSupplierTitle: item.financialSupplierTitle,
        isBySupplierCredit: item.isBySupplierCredit,
        supplierCredit: item.supplierCredit,
      };
    });
  const childInfo = <ConfirmationCard value={listloan} />;
  const childVerificationCode = (
    <FacitlityActivationCmp handleNext={handleNext} />
  );
  return (
    <Box>
      <DivisionCmp child={childInfo} />
      <DivisionCmp child={childVerificationCode} />
    </Box>
  );
}
